export const app = { getPath: (): void => undefined };

export const isElectron = (): boolean => false;
